/** Get a particular redux state / reducer */

import { RootState } from "../../store/store";

const StoreSelectors = {
  USER_STATE: (state: RootState) => state.authentication,
  ALERT_STATE: (state: RootState) => state.alertState,
  PAGE_STATE: (state: RootState) => state.pageData,
  LOADER_STATE: (state: RootState) => state.loaderState,
  TOAST_STATE: (state: RootState) => state.toastState,
  PAGE_HEADER_STATE: (state: RootState) => state.pageHeaderState,
};

export default StoreSelectors;
